import {
  Portion,
  PortionResource,
  PortionResourcePage,
  PortionResourcePayload,
  PageOf,
  PortionPageQuery
} from '@/models'

import axios, { withToken } from '../axios'

export function parsePortionResource (resource: PortionResource): Portion {
  return {
    id: resource.id,
    name: resource.name,
    price: resource.price,
    createdAt: new Date(resource.createdAt),
    isAvailable: resource.isAvailable
  }
}

export function parsePortionResourcePage (page: PortionResourcePage): PageOf<Portion> {
  return {
    elements: page.portions.map(parsePortionResource),
    total: page.count
  }
}

export async function createPortion (
  tokenv2: string,
  accountId: number,
  shopId: number,
  itemId: number,
  payload: PortionResourcePayload
): Promise<Portion> {
  const response = await axios.post<PortionResource>(
    `menu/accounts/${accountId}/shops/${shopId}/items/${itemId}/portions`,
    payload,
    withToken(tokenv2)
  )

  return parsePortionResource(response.data)
}

export async function deletePortion (
  tokenv2: string,
  accountId: number,
  shopId: number,
  itemId: number,
  portionId: number
): Promise<void> {
  await axios.delete<void>(
    `menu/accounts/${accountId}/shops/${shopId}/items/${itemId}/portions/${portionId}`,
    withToken(tokenv2)
  )
}

export async function fetchPortion (
  tokenv2: string,
  accountId: number,
  shopId: number,
  itemId: number,
  portionId: number
): Promise<Portion> {
  const response = await axios.get<PortionResource>(
    `menu/accounts/${accountId}/shops/${shopId}/items/${itemId}/portions/${portionId}`,
    withToken(tokenv2)
  )

  return parsePortionResource(response.data)
}

export async function fetchPortionPage (
  tokenv2: string,
  accountId: number,
  shopId: number,
  itemId: number,
  query: PortionPageQuery
): Promise<PageOf<Portion>> {
  const response = await axios.get<PortionResourcePage>(
    `menu/accounts/${accountId}/shops/${shopId}/items/${itemId}/portions`,
    {
      params: query,
      ...withToken(tokenv2)
    }
  )

  return parsePortionResourcePage(response.data)
}

export async function updatePortion (
  tokenv2: string,
  accountId: number,
  shopId: number,
  itemId: number,
  portionId: number,
  payload: PortionResourcePayload
): Promise<Portion> {
  const response = await axios.put<PortionResource>(
    `menu/accounts/${accountId}/shops/${shopId}/items/${itemId}/portions/${portionId}`,
    payload,
    withToken(tokenv2)
  )

  return parsePortionResource(response.data)
}

export default {
  createPortion,
  deletePortion,
  fetchPortion,
  fetchPortionPage,
  updatePortion
}
